import React, { useState, useEffect } from 'react';
import { creatorAPI } from '../../../api';
import { areaByKey } from '../constants';
import ItemRow from './ItemRow';

// List of items inside one area (or search results / type-filtered lists).
export default function AreaView({ areaKey, query, typeFilter, title, t, locale, onOpen, onBack, refreshKey }) {
  const [items, setItems] = useState(null);
  const [statusFilter, setStatusFilter] = useState('open');
  const area = areaByKey(areaKey);

  useEffect(() => {
    const params = {};
    if (query) params.q = query;
    else {
      if (areaKey) params.area = areaKey;
      if (typeFilter) params.type = typeFilter;
      if (statusFilter !== 'all') params.status = statusFilter;
    }
    creatorAPI.items(params).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [areaKey, query, typeFilter, statusFilter, refreshKey]);

  const toggleDone = async (item) => {
    await creatorAPI.update(item.id, { status: item.status === 'done' ? 'open' : 'done' });
    setItems((prev) => prev.map((i) => (i.id === item.id ? { ...i, status: item.status === 'done' ? 'open' : 'done' } : i)));
  };

  return (
    <div className="crs-areaview" data-testid="creator-area-view">
      <button type="button" className="crs-backlink" onClick={onBack} data-testid="creator-area-back">
        ← {t.cr_title || 'Creator Space'}
      </button>
      <div className="crs-areaview__head">
        <h2>{query ? `${t.cr_results_for || 'Results for'} \u201e${query}\u201d` : (title || area?.name || '')}</h2>
        {!query && (
          <nav className="crs-filter">
            {[['open', t.cr_open || 'Open'], ['done', t.cr_done || 'Done'], ['all', t.cr_all || 'All']].map(([k, label]) => (
              <button
                key={k}
                type="button"
                className={statusFilter === k ? 'is-on' : ''}
                onClick={() => setStatusFilter(k)}
                data-testid={`creator-filter-${k}`}
              >{label}</button>
            ))}
          </nav>
        )}
      </div>
      {!query && area && t[`cr_area_desc_${area.key}`] && (
        <p className="crs-areaview__desc" data-testid="creator-area-description">
          {t[`cr_area_desc_${area.key}`]}
        </p>
      )}
      {items === null ? (
        <div className="spinner" style={{ margin: '48px auto' }} />
      ) : items.length === 0 ? (
        <p className="crs-empty" data-testid="creator-area-empty">{query ? (t.cr_no_results || 'Nothing found.') : (t.cr_area_empty || 'Nothing here yet.')}</p>
      ) : (
        <div className="crs-list">
          {items.map((it) => (
            <ItemRow key={it.id} item={it} t={t} locale={locale} onOpen={onOpen} onToggleDone={toggleDone} />
          ))}
        </div>
      )}
    </div>
  );
}
